import { Store } from 'src/store/index';

const getDisplayAddToBasketUpsell = (store: Store) => store.upsell.displayUpsellBeforeAddToBasket;
export default getDisplayAddToBasketUpsell;
